loadingButton = (button) ->
	jQuery(button).toggleClass 'button--loading'

isModalOpen = (modal = '') ->
	if modal.length
		modal = jQuery("#modal-#{modal}").closest '#modal'
	else
		modal = jQuery("#modal")
	if modal.length
		return true
	return false

closeModal = (modal = '', afterClose = null) ->
	if modal.length
		modal = jQuery("#modal-#{modal}").closest '#modal'
	else
		modal = jQuery("#modal")

	jQuery("body").removeClass 'noflow'
	modal.removeClass 'show'
	setTimeout ->
		modal.remove()

		if afterClose?
			afterClose modal
		else if modal.attr('data-close-redirect')?
			window.location.href = modal.attr('data-close-redirect')
	, 500

createModal = (name, args = {}, afterCreate = null) ->
	if isModalOpen name
		return
	else if isModalOpen()
		closeModal()

	source = jQuery("#modal-template").html()
	if source
		template = Handlebars.compile source
		html = template jQuery.extend {modal: name}, args
		jQuery(html).appendTo("body").delay(10).queue (next) ->
			jQuery("body").addClass 'noflow'
			jQuery(@).addClass 'show'
			if afterCreate?
				afterCreate jQuery(@), html, name, args
			next()

preloadModal = (name, loadFunction) ->
	if isModalOpen name
		return
	else if isModalOpen()
		closeModal()

	source = jQuery("#preload-modal-template").html()
	if source
		template = Handlebars.compile source
		html = template
			modal: name
		jQuery(html).appendTo("body").delay(10).queue (next) ->
			modal = jQuery(@)

			jQuery("body").addClass 'noflow'
			jQuery(@).addClass 'show'

			loadFunction().done (results) ->
				args =
					modal: name
					modal_title: results.modal_data.product.full_title

				if typeof Handlebars.partials['modal_box'] is 'function'
					template = Handlebars.partials['modal_box']
				else
					template = Handlebars.compile Handlebars.partials['modal_box']

				html = template jQuery.extend(args, results.modal_data)
				jQuery(html).appendTo(modal).delay(10).queue (next) ->
					modal.addClass 'loaded'

clearMessages = (context = 'body') ->
	jQuery(".page-message", context).remove()

createFormMessage = (form, message, type = 'success') ->
	message = jQuery('<div class="page-message page-message--'+type+'">'+message+'</div>')
	form.prevAll('.page-message').remove()
	form.before message

createPageMessage = (context, message, type = 'success') ->
	message = jQuery('<div class="page-message page-message--'+type+'">'+message+'</div>')
	jQuery(".page-messages", context).html('').append message

(($) ->

	$("body").on 'click', '#modal', (e) ->
		e.preventDefault()
		closeModal()

	$("body").on 'click', '#modal .modal-close, #modal .buttons-cancel', (e) ->
		e.preventDefault()
		closeModal()

	$("body").on 'click', '#modal .modal-box', (e) ->
		e.stopPropagation()

	$("body").on 'click', '.create-modal', (e) ->
		e.preventDefault()
		args =
			modal: $(@).data 'modal'
			modal_title: $(@).data 'modal-title'
			href: $(@).attr 'href'

		if $(@)[0].hasAttribute 'data-modal-args'
			args = $(@).data 'modal-args'
			
		createModal args.modal, args

	$("body").on 'click', 'a.close-modal', (e) ->
		e.preventDefault()
		closeModal()

	$("body").on 'click', '.wtb-tabs .tabs-item', (e) ->
		e.preventDefault()

		action = $(@).attr('href').replace '#', ''

		$(@).addClass('tabs-item--active').siblings().removeClass 'tabs-item--active'
		$(".wtb-tabs-action--#{action}").show().siblings('.wtb-tabs-action').hide()

	$(".form-field[data-conditions]").each ->
		conditions = $(@).data 'conditions'
		field = $(@)

		$.each conditions, (i, v) ->
			cond_field = $("##{v.field}")

			cond_field.on 'change', (e) ->
				switch cond_field.attr 'type'
					when 'checkbox'
						if cond_field.is ':' + v.value
							field.show()
						else
							field.hide()


	if window.location.search.length
		do_index = window.location.search.indexOf '?do'
		if do_index > -1
			window.history.replaceState {}, document.title, window.location.origin + window.location.pathname

) jQuery